var _radialGradient, _ellipse, _line, _line2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLampOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 120,
    viewBox: "0 0 80 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bulbOn",
    cx: "50%",
    cy: "40%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fffde7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#fff176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f59e0b"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40,
    rx: 30,
    ry: 35,
    fill: "url(#bulbOn)",
    stroke: "#b45309",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 40,
    x2: 50,
    y2: 40,
    stroke: "#facc15",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 30,
    x2: 40,
    y2: 50,
    stroke: "#facc15",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 70,
    width: 24,
    height: 20,
    fill: "#374151",
    stroke: "#111827",
    strokeWidth: 2,
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 90,
    width: 28,
    height: 10,
    fill: "#4b5563",
    stroke: "#111827",
    strokeWidth: 1,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampOn);
export default __webpack_public_path__ + "static/media/LampON.0d6915c331c13a876499308e71628489.svg";
export { ForwardRef as ReactComponent };